import { productImageStyles } from "@insite/content-library/Components/ProductImage";
import Img, { ImgProps } from "@insite/mobius/Img";
import { css } from "styled-components";

productImageStyles.linkWrappingImage={
    css: css`
        width: auto;
        justify-content:center;
    `,
}

productImageStyles.image={
    css: css`
        width: auto;
        max-height: 300px;
    `,
    
}

productImageStyles.img={
    css: css` 
    display: block;
    height: auto;
    margin: 0 auto;
    max-height: 300px;
    max-width: 100%;
    position: relative;
    width: auto;
    `,  
}